<template>
  <div
    class="seasidetms_row seasidetms_color_scheme_default seasidetms_row_top_default seasidetms_row_bot_default seasidetms_row_boxed"
  >
    <div class="seasidetms_row_outer_parent">
      <div class="seasidetms_row_outer">
        <div class="seasidetms_row_inner">
          <hr />
          <div class="seasidetms_row_margin seasidetms_11">
            <div
              id="seasidetms_column_hir3kgnnpf"
              class="seasidetms_column one_first"
            >
              <div
                class="seasidetms_column_inner slider"
                id="seasidetms_heading_i8j83oo6mg"
              >
                <div class="h3" style="text-align: center">
                  {{ $t('reviews') }}
                </div>
                <div
                  class="seasidetms_posts_slider seasidetms_posts_slider_product"
                >
                  <carousel
                    :nav="false"
                    :items="1"
                    :autoplayTimeout="5000"
                    :autoplaySpead="2500"
                    :autoplay="true"
                    :responsive="{
                      0: { items: 1, nav: true },
                      1024: { items: 1, nav: false },
                    }"
                  >
                    <article class="seasidetms_quote_inner review">
                      <div class="seasidetms_quote_content">
                        <p>
                          Доброго дня! Купив у вас iPhone X тиждень тому.
                          Спочатку трохи хвилювався, так як телефон не новий.
                          Але реально стан 10/10, дуже задоволений. Ціна просто
                          🔥, якість теж супер. Дякую, в майбутньому буду теж
                          купувати у вас😊
                        </p>
                      </div>
                      <div class="seasidetms_user_block">
                        <figure class="seasidetms_quote_image">
                          <img width="150" height="150" src="/img/user.svg" />
                        </figure>
                        <header class="seasidetms_quote_header">
                          <div class="h3 seasidetms_quote_title">Дмитро</div>
                        </header>
                      </div>
                    </article>
                    <article class="seasidetms_quote_inner review">
                      <div class="seasidetms_quote_content">
                        <p>
                          Получил уже второй раз новый телефон и слова мои ни в
                          коем случае не меняются! Телефон пришел в идеальном
                          состоянии, без ЕДИНОЙ царапины. Магазин сделал хорошую
                          скидку, к тому же, я продлил гарантию на год по сумме,
                          которая равняется пол года. Очень приятные бонусы,
                          менеджеры и обслуживание. Можете смело покупать тут
                          телефоны. Рекомендую всем!
                        </p>
                      </div>
                      <div class="seasidetms_user_block">
                        <figure class="seasidetms_quote_image">
                          <img width="150" height="150" src="/img/user.svg" />
                        </figure>
                        <header class="seasidetms_quote_header">
                          <div class="h3 seasidetms_quote_title">Станислав</div>
                        </header>
                      </div>
                    </article>
                    <article class="seasidetms_quote_inner review">
                      <div class="seasidetms_quote_content">
                        <p>
                          Немного с опоздание, но все же хотелось бы оставить
                          отзыв) уже неделю как пользуюсь телефоном купленным у
                          вас, и могу сказать уверенно что все работает как
                          часики, телефоном доволен, за свои деньги это отличный
                          аппарат, цена одна из первых на рынке, буду
                          рекомендовать друзьям ваш магазин, еще хотелось бы
                          оставить отзыв о сервисном центре, после покупки было
                          обнаружено пару недочетов, которые были оперативно
                          устранены по гарантии, следов вмешательств в телефон
                          нету, сделали все и даже больше))
                        </p>
                      </div>
                      <div class="seasidetms_user_block">
                        <figure class="seasidetms_quote_image">
                          <img width="150" height="150" src="/img/user.svg" />
                        </figure>
                        <header class="seasidetms_quote_header">
                          <div class="h3 seasidetms_quote_title">Сергей</div>
                        </header>
                      </div>
                    </article>
                    <article class="seasidetms_quote_inner review">
                      <div class="seasidetms_quote_content">
                        <p>
                          Хотела вас поблагодарить за телефон) Я уже день
                          пользуюсь и уже успела проверить много функций. Пока
                          мне все нереально нравится. Быстро работает, батарея
                          очень медленно садится, осталось только проверить
                          камеру в работе)) Спасибо большое, обязательно к вам
                          буду обращаться по поводу новых покупок)
                        </p>
                      </div>
                      <div class="seasidetms_user_block">
                        <figure class="seasidetms_quote_image">
                          <img width="150" height="150" src="/img/user.svg" />
                        </figure>
                        <header class="seasidetms_quote_header">
                          <div class="h3 seasidetms_quote_title">Татьяна</div>
                        </header>
                      </div>
                    </article>
                  </carousel>
                </div>
                <p>
                  <a
                    href="https://www.instagram.com/apptown.ua/"
                    target="_blank"
                  >
                    <i class="fa fa-link"></i>
                    {{ $t('instLink') }}
                  </a>
                </p>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'

export default {
  name: 'ProductsSlider',
  components: { carousel },
}
</script>

<style>
.review {
  /* text-align: center; */
}
.review p {
  /* text-align: center; */
  font-size: 18px;
}
.review img {
  width: 75px !important;
  margin: 0 auto;
  border-radius: 50%;
}

.seasidetms_quote_inner.review {
  display: flex;
  flex-direction: row-reverse;
  margin: 0 50px;
}

.seasidetms_user_block {
  min-width: 120px;
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 30px;
}

.review p {
  font-size: 18px;
  text-align: left;
}

@media only screen and (max-width: 1024px) {
  #seasidetms_heading_i8j83oo6mg h3,
  #seasidetms_heading_i8j83oo6mg .h3 {
    font-size: 20px !important;
  }
}

@media only screen and (max-width: 650px) {
  .seasidetms_quote_inner.review {
    flex-direction: column-reverse;
    margin: 0 15px;
  }
}
</style>
